import * as UI from "@iyk/music-ui"
import React from "react"
import { Meta } from "../ui/Meta.tsx"
import type { Route } from "./+types/HomeRoute.ts"

export default function Home(_: Route.ComponentProps) {
  return (
    <React.Fragment>
      <Meta path="/" />
      <main className="h-dvh flex flex-col items-center justify-center">
        <UI.Icon.IykLogo className="size-7" />
      </main>
    </React.Fragment>
  )
}
